import { Button } from "@mui/material";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";

export default () => {
  const navigate = useHistory();
  const location = useLocation();
  return (
    <header>
      <nav className="w-full py-8 flex flex-row bg-bg-purple items-center justify-between px-4">
        <div
          onClick={() => {
            navigate.push("/");
          }}
          className="text-3xl abc-regular font-bold md:ml-10 text-amber-50 cursor-pointer"
        >
          BiodataMaker
        </div>
        <div className="mr-10 hidden md:block">
          {location.pathname === `/` && (
            <button
              onClick={() => {
                document
                  .getElementById("create-biodata")
                  .scrollIntoView({ behavior: "smooth" });
              }}
              class="relative inline-flex items-center justify-center p-0.5 mb-2 me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-purple-500 to-pink-500 group-hover:from-purple-500 group-hover:to-pink-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-purple-200 dark:focus:ring-purple-800"
            >
              <span class="relative font-bold px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                Create Your Biodata Now
              </span>
            </button>
          )}
        </div>
      </nav>
    </header>
  );
};
